import React from 'react';
import tw from 'twin.macro';
import {
  GreenLine as Green,
  OrangeLine as Orange,
  YellowLine as Yellow,
} from './Lines';

export function Background() {
  return (
    <div tw="relative flex-1 overflow-hidden h-screen">
      <div tw="size-full bg-brand-intense pointer-events-none">
        <div
          css={[
            tw`absolute rotate-[25deg] scale-[1.4] top-0 right-0 translate-y-6 -translate-x-4`,
            tw`md:rotate-0 md:scale-[3] md:-translate-y-20 md:-translate-x-2/3`,
            tw`lg:scale-100 lg:left-1/2 lg:-translate-x-1/2 lg:-translate-y-1/2`,
          ]}
        >
          <Green />
        </div>
        <div
          css={[
            tw`absolute rotate-45 top-1/2 left-0 -translate-y-1/2 -translate-x-1/2`,
            tw`md:scale-[1.75]`,
            tw`lg:rotate-0 lg:top-auto lg:left-auto lg:bottom-0 lg:right-0 lg:scale-[2] lg:-translate-y-1/3 lg:translate-x-0`,
          ]}
        >
          <div tw="-scale-x-100 lg:scale-x-100">
            <Orange />
          </div>
        </div>
        <div
          css={[
            tw`absolute -rotate-[75deg] scale-150 bottom-0 right-0 translate-y-20`,
            tw`md:-rotate-90 md:scale-[4] md:-translate-x-1/2`,
            tw`absolute lg:rotate-0 lg:right-auto lg:left-0 lg:-bottom-20 lg:-translate-y-full lg:translate-x-1/2`,
          ]}
        >
          <Yellow />
        </div>
      </div>
    </div>
  );
}
